import SelectObject from './SelectObject.connect';

export default SelectObject;
